<div class="footer">
    <div class="h11 m-auto">About the author</div>
    <div class="author-image">
        <img class="author-face" src="/assets/my_face.png">
    </div>
    <!-- <span class="footer-item">Contact me</span>
    <span class="footer-item">About.</span>
    <span class="footer-item">Project Notebook</span> -->
</div>